import React, { useRef, useState, useLayoutEffect } from 'react';
import { Router } from 'react-router';
import type { History } from 'history';

export interface HistoryRouterProps {
  basename?: string;
  children?: React.ReactNode;
  history: History;
}

function HistoryRouter({ basename, children, history }: HistoryRouterProps) {
  const [state, setState] = useState({
    action: history.action,
    location: history.location,
  });

  const lastLocationRef = useRef(history.location);

  useLayoutEffect(() => {
    const writeNavMeta = (fromLocation: typeof state.location, toLocation: typeof state.location) => {
      try {
        const fromUrl = `${fromLocation.pathname}${fromLocation.search}${fromLocation.hash}`;
        const toUrl = `${toLocation.pathname}${toLocation.search}${toLocation.hash}`;
        sessionStorage.setItem('app:navFrom', fromUrl);
        sessionStorage.setItem('app:navTo', toUrl);
        sessionStorage.setItem('app:navFromPath', fromLocation.pathname);
        sessionStorage.setItem('app:navToPath', toLocation.pathname);
        sessionStorage.setItem('app:navAt', String(Date.now()));
      } catch {
        // ignore storage failures (private mode / quota / SSR)
      }
    };

    // Initialize for first render (direct load / refresh).
    writeNavMeta(lastLocationRef.current, lastLocationRef.current);

    const unlisten = history.listen(update => {
      const fromLocation = lastLocationRef.current;
      lastLocationRef.current = update.location;
      writeNavMeta(fromLocation, update.location);
      setState(update);
    });

    return unlisten;
  }, [history]);

  return (
    <Router
      basename={basename}
      location={state.location}
      navigationType={state.action}
      navigator={history}
    >
      {children}
    </Router>
  );
}

export default HistoryRouter;
